import { render, staticRenderFns } from "./EmployeeFeedbacks.vue?vue&type=template&id=c07d56ca&scoped=true"
import script from "./EmployeeFeedbacks.vue?vue&type=script&lang=js"
export * from "./EmployeeFeedbacks.vue?vue&type=script&lang=js"
import style0 from "./EmployeeFeedbacks.vue?vue&type=style&index=0&id=c07d56ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07d56ca",
  null
  
)

export default component.exports